<template>
  <div ref="Number" class="w-full md:w-full h-full flex items-stretch relative">
    <input
      autocomplete="off"
      :value="answer"
      @keyup="sendAnswer($event)"
      id="inputNumber"
      ref="inputNumber"
      style="font-size: 16px"
      class="h-full border w-full px-2 py-2 bg-transparent text-center font-family"
      type="text"
      :class="{
        'border-danger': !_validate,
        'rounded-l-lg': !_validate,
        'rounded-lg': _validate
      }"
    />
    <div
      class="px-2 flex items-center cursor-pointer border-danger rounded-r-lg border-left-0"
      v-if="!_validate"
      @click="isToolTip = !isToolTip"
    >
      <feather-icon class="text-danger" icon="InfoIcon" svgClasses="w-5 h-5" />
    </div>

    <div ref="toolTipE">
      <div v-if="isToolTip" class="absolute left-0 bottom-0 top-36 _black text-white rounded-lg px-2 pt-2 pb-8 w-full">
        El rango del valor debe ser entre {{ question.properties.minValue }} y {{ question.properties.maxValue }}
      </div>
    </div>
  </div>
</template>

<script>
import mixins from "./mixinsNumberCurrency";
export default {
  mixins: [mixins],
  props: {
    value: {
      type: String | Number,
      required: false
    },
    Item: {
      type: Object,
      required: true,
      default: ""
    },
    change: {
      type: Promise | Function,
      required: true,
      default: () => {}
    },
    question: {
      type: Object,
      required: true
    }
  },
  watch: {
    _validate(value) {
      if (value) this.isToolTip = false;
    }
  },
  data: () => ({
    isToolTip: false
  }),
  methods: {
    sendAnswer(e) {
      if (this.validateKeyBoards(e.key)) {
        const dato = this.answer + e.key;
        e.target.value = this.formaterCurrency(dato);
      } else {
        e.target.value = this.formaterCurrency(e.target.value);
      }

      const validate = this.validate(e.target.value);
      this.$emit("validate", validate);
      this.answer = this.removeFormatter(e.target.value);
    },
    validate(value) {
      const number = this.removeFormatter(value);
      if (number >= this.min && number <= this.max) return true;
      return false;
    }
  },
  computed: {
    answer: {
      get() {
        return this.formaterCurrency(String(this.value));
      },
      async set(value) {
        if (isNaN(value)) return this.$emit("input", "");
        else this.$emit("input", value);
        this.change(value, this.Item);
      }
    },
    min() {
      return this.question.properties.minValue;
    },
    max() {
      return this.question.properties.maxValue;
    },
    _validate() {
      return this.validate(String(this.value));
    }
  }
};
</script>

<style lang="scss" scoped>
.font-family {
  font-family: Montserrat, Helvetica, Arial, sans-serif;
  font-weight: 400;
}

.border-left-0 {
  border-left: none !important;
}

.top-36 {
  top: 39px;
  z-index: 1;
}

._black {
  background-color: black;
}
</style>
